// @react-functional

import React from 'react';
import { ToastContent, toast } from 'react-toastify';
import { CloseToasterButton } from '../../components/toaster/close/CloseToasterButton';

export function folderToast(component: ToastContent) {
  return toast(() => component, {
    autoClose: 7000,
    pauseOnHover: true,
    closeOnClick: false,
    closeButton: <CloseToasterButton />,
  });
}
